import { defineMessages } from 'react-intl'

export default defineMessages({
  allRightsReserved: {
    id: 'footer.allrightsreserved',
    defaultMessage: 'All rights reserved',
  },
  termsAndConditions: {
    id: 'footer.termsandconditions',
    defaultMessage: 'Terms & Conditions',
  },
  privacyPolicy: {
    id: 'footer.privacypolicy',
    defaultMessage: 'Privacy policy',
  },
  cookies: {
    id: 'footer.cookies',
    defaultMessage: 'Cookies',
  },
  faqs: {
    id: 'footer.faqs',
    defaultMessage: 'FAQs',
  },
  regulatory: {
    id: 'footer.regulatory',
    defaultMessage: 'Regulatory',
  },
})
